import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { UserGuideComponent } from 'src/app/Components/user-guide/user-guide.component';
import { UserGuideService } from 'src/app/Components/user-guide/user-guide.service';

@Injectable({
  providedIn: 'root'
})
export class GuideServiceService {
  forceRefresh$: BehaviorSubject<string> = new BehaviorSubject('');

  constructor(private userGuide: UserGuideService, private modal: NgbModal) { }

  getUserguide(event) {
    const userGuidText = this.userGuide.userGuideText.find(x => x.name == event)
    if(userGuidText){
      const dialogRef = this.modal.open(UserGuideComponent, {
        centered: true,
        keyboard: true,
        size: "lg",
        modalDialogClass: 'user-guide-modal',
      })
      dialogRef.componentInstance.showDontshowClick = false;
      dialogRef.componentInstance.info = userGuidText;
    }    
  }
  refresh(val) {
    this.forceRefresh$.next(val);
  } 
    
}
